module.exports = __webpack_public_path__ + "static/media/weather_app_img.67d9446d.png";